import { useInfiniteQuery } from "@tanstack/react-query";

import { useRestApi } from "@/context/api";
import { useCurrentCompany } from "@/context/auth";
import { queryKeys } from "@/queries/queryKeys";

/** Keyset cursor: rows sharing one `changedOn` are only skipped when the id is sent with it. */
interface UserChangesCursor {
  before: string;
  beforeId: number;
}

export const useUserChangesInfiniteQuery = (userId: string, enabled: boolean) => {
  const { getUserChanges } = useRestApi().userChanges;
  const currentCompany = useCurrentCompany();

  return useInfiniteQuery({
    queryKey: [queryKeys.USER_CHANGES, currentCompany.id, userId],
    queryFn: ({ pageParam }) =>
      getUserChanges(currentCompany.id, userId, {
        size: 20,
        before: pageParam?.before,
        beforeId: pageParam?.beforeId,
      }),
    initialPageParam: null as UserChangesCursor | null,
    getNextPageParam: (lastPage) => {
      if (!lastPage.hasMore || lastPage.items.length === 0) {
        return null;
      }
      const last = lastPage.items[lastPage.items.length - 1];
      return { before: last.changedOn, beforeId: last.id };
    },
    enabled,
    staleTime: 30000,
  });
};
